import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type Props = {
    onReload: () => void;
    onGoToLobby: () => void;
    insetBottom?: boolean;
};

export const GameErrorOverlay = ({ onReload, onGoToLobby, insetBottom = true }: Props) => {
    const { t } = useTranslation('common');
    const safeInsets = useSafeAreaInsets();

    return (
        <Box style={styles.container} px="s16">
            <Box flex={1} justifyContent="center">
                <Text variant="titleLarge" textAlign="center">
                    {t('something_went_wrong')}
                </Text>
            </Box>
            <Box gap="s8" style={{ paddingBottom: (insetBottom ? safeInsets.bottom : 0) + 16 }}>
                <Button label={t('retry')} hierarchy="primary" onPress={onReload} />
                <Button label={t('go_to_lobby')} onPress={onGoToLobby} />
            </Box>
        </Box>
    );
};

const styles = StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: ds.colorValue.background.neutral.base,
    },
});
